<template>
  <span>
    <el-button type="primary" @click="showdialog">{{ title }}</el-button>
    <el-dialog
      title="选择使用返利"
      :visible.sync="dialogVisible"
      width="800px"
      top="0"
      append-to-body
    >
      <el-form ref="form" :inline="true" :model="searchForm">
        <el-form-item label="到期日:" prop="expireStartDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">-</div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="返利类型" prop="rebateType">
          <el-select v-model="searchForm.rebateType">
            <el-option v-for="(value,key) of typeList" :key="key" :value="key" :label="value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="()=>{rest();}">搜索</el-button>
        </el-form-item>
      </el-form>
      <div>
        <span v-if="yanzheng && allow > availableRebateAmount" style="display: inline-block;margin-right: 10px">当前合同最大可用返利金额：{{ availableRebateAmount }}元;</span>
        <span v-if="yanzheng && allow <= availableRebateAmount" style="display: inline-block;margin-right: 10px">当前合同最大可用返利金额：{{ allow }}元;</span>
        <span style="display: inline-block"> 已选返利金额：{{ totalChoose }}元</span>
      </div>
      <el-form ref="multipleForm" :inline="true" :model="multipleForm" :rules="multipleFormRules" style="margin-top: 18px">
        <el-form-item label="使用返利总金额:" prop="transferAmountTotal">
          <el-input-number
            v-model="multipleForm.transferAmountTotal"
            :min="0"
            :max="getMaxNumber()"
            :precision="2"
            :controls="false"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item>
          <el-button :loading="tableLoading" type="primary" @click="setDeductionDevice">设置使用</el-button>
        </el-form-item>
      </el-form>
      <!-- 改为监听表格滚动加载，避免 append 内容被渲染进表体后多出一条空白行 -->
      <el-table id="rabateTable" ref="multipleTable" v-loadmore="handleLoadMore" v-loading="tableLoading" :data="tableData"
                style="width: 100%" border :max-height="400"
                row-key="id"
                @select="selectOne"
                @select-all="selectAll"
      >
        <el-table-column
          type="selection"
          width="50"
          reserve-selection
          align="left"
          fixed="left"
        />
        <el-table-column
          label="返利编号"
          align="left"
          prop="rebateNumber"
        />
        <el-table-column
          prop="strRebateType"
          label="返利类型"
          align="left"
        />
        <el-table-column
          prop="rebateAmount"
          label="总金额"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="grantDate"
          label="发放日期"
          align="left"
        />
        <el-table-column
          prop="expireDate"
          label="到期日"
          align="left"
        />
        <el-table-column
          prop="availableAmount"
          label="可用余额"
          align="right"
          header-align="left"
        />
        <el-table-column
          label="使用金额"
          align="right"
          header-align="left"
          fixed="right"
        >
          <template v-slot="{row}">
            <el-input-number v-model="row.transferAmount" :min="0" :precision="2" :disabled="row.isSelect" size="mini" :controls="false" style="width: 100%" @blur="transferAmountBlur(row)" />
          </template>
        </el-table-column>
      </el-table>
      <!-- 将加载状态放到表格外，避免参与行高计算导致 fixed 列错位 -->
      <div v-if="isSearchLoading || isLoadCompleted" style="padding: 12px 0; text-align: center; color: #909399;">
        <span v-if="isSearchLoading">加载中...</span>
        <span v-else-if="tableData.length">加载完成</span>
        <span v-else>暂时无数据</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTransfer">确认</el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script type="es6">
import { selectRebateTypeList, selectAgentAvailableRebate, getLoginUser } from '@/API';
import { MathAdd } from '../../../libs/util';
import { getNum, numAdd } from '@/libs/util';
import Big from 'big.js';

export default {
  directives: {
    loadmore (el, binding) {
      const selectWrap = el.querySelector('.el-table__body-wrapper');
      if (!selectWrap) {
        return;
      }
      selectWrap.addEventListener('scroll', function () {
        if (this.scrollHeight - Math.ceil(this.scrollTop) - this.clientHeight <= 2) {
          binding.value();
        }
      });
    }
  },
  data () {
    return {
      isSMB: false,
      dialogVisible: false,
      searchForm: {
        rebateType: '',
        expireStartDate: '',
        expireEndDate: ''
      },
      tableLoading: false,
      // 控制表格外部的加载中提示，并防止重复请求下一页。
      isSearchLoading: false,
      // 标记是否已加载完所有分页数据。
      isLoadCompleted: false,
      tableData: [],
      multipleSelection: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeList: {},
      multipleForm: {
        transferAmountTotal: 0
      },
      multipleFormRules: {
        transferAmountTotal: [
          { required: true, message: '请输入扣减总金额', trigger: 'blur' },
          { type: 'number', min: 0, max: 9999999999.99, message: '请输入正确的扣减总金额', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    title: {
      type: String,
      default: '填选返利'
    },
    allow: {
      type: Number,
      default: 0
    },
    availableRebateAmount: {
      type: Number,
      default: 0
    },
    yanzheng: {
      type: Boolean,
      default: true
    },
    householdProducts: {
      type: Number,
      default: 0
    },
    needReload: {
      type: Boolean,
      default: false
    },
    excludeList: {
      type: Array,
      default: () => { return []; }
    },
    customerContractType: {
      type: String,
      default: ''
    }
  },
  computed: {
    totalChoose () {
      let count = 0;
      this.multipleSelection.forEach((item) => {
        count = MathAdd(count, getNum(item.transferAmount));
      });
      return count.toFixed(2);
    },
    excludeIds () {
      let list = [];
      this.excludeList.forEach((item) => {
        list.push(item.rebateNumber);
      });
      return list;
    }
  },
  methods: {
    showdialog () {
      this.dialogVisible = true;
      if (this.needReload) {
        this.rest();
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      } else if (!this.tableData.length) {
        this.dosearch();
      }
      this.selectRebateTypeList();
    },
    getUser () {
      getLoginUser().then(res => {
        const { status, data } = res.data || {};
        if (status === '200' && data) {
          this.isSMB = data.industryORSMB === 'SMB' || data.industryORSMB === 'smb';
        }
      });
    },
    selectRebateTypeList () {
      let params = { agentTypeName: this.customerContractType };
      selectRebateTypeList(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.typeList = json.data;
        }
      }).catch(() => {

      });
    },
    // 仅在弹窗打开、未加载完、且当前不在请求中时继续拉取下一页。
    handleLoadMore () {
      if (!this.dialogVisible || this.isLoadCompleted || this.isSearchLoading) {
        return;
      }
      this.dosearch();
    },
    dosearch () {
      if (this.isSearchLoading) {
        return;
      }
      // 当前已拿到总数且列表条数已追平总数时，直接结束加载。
      if (this.page.total && this.page.total <= this.tableData.length) {
        this.isLoadCompleted = true;
        return;
      }
      this.isSearchLoading = true;
      selectAgentAvailableRebate({
        ...this.searchForm,
        lists: this.excludeIds,
        householdProducts: this.isSMB ? null : [1, 2].includes(Number(this.householdProducts)),
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.page.total = json.data.total;
          this.page.currentPage++;
          json.data.list.forEach((item) => {
            item.isSelect = true;
          });
          this.tableData = this.tableData.concat(json.data.list);
          this.isLoadCompleted = json.data.total === 0 || this.tableData.length >= json.data.total;
          this.$nextTick(() => {
            this.tryLoadMoreWhenNoScrollbar();
          });
        }
      }).catch(() => {

      }).finally(() => {
        this.isSearchLoading = false;
      });
    },
    tryLoadMoreWhenNoScrollbar () {
      const tableBody = this.$refs.multipleTable && this.$refs.multipleTable.bodyWrapper;
      if (!tableBody || this.isLoadCompleted || this.isSearchLoading) {
        return;
      }
      if (tableBody.scrollHeight <= tableBody.clientHeight) {
        this.dosearch();
      }
    },
    // 搜索条件变化后重置分页，并在弹窗打开时自动重查第一页。
    rest () {
      this.page.currentPage = 1;
      this.page.total = 0;
      this.tableData = [];
      this.isLoadCompleted = false;
      this.isSearchLoading = false;
      if (this.dialogVisible) {
        this.$nextTick(() => {
          this.dosearch();
        });
      }
    },
    restFormAction () {
      this.searchForm.expireEndDate = '';
      this.$refs.form.resetFields();
      this.rest();
      // this.dosearch();
    },
    // 只能使用最大的返利金额
    judgeMaxMoney (row) {
      let totalChoose = getNum(this.totalChoose);
      let allow = getNum(this.allow);
      let availableRebateAmount = getNum(this.availableRebateAmount);
      let availableAmount = getNum(row.availableAmount);
      let count = 0;

      if (allow > availableRebateAmount) {
        if (totalChoose >= availableRebateAmount) {
          count = 0;
        } else {
          if (Big(availableRebateAmount).minus(totalChoose).toNumber() > availableAmount) {
            count = availableAmount;
          } else {
            count = Big(availableRebateAmount).minus(totalChoose).toNumber();
          }
        }
      } else {
        if (totalChoose >= allow) {
          count = 0;
        } else {
          if (Big(allow).minus(totalChoose).toNumber() > availableAmount) {
            count = availableAmount;
          } else {
            count = Big(allow).minus(totalChoose).toNumber();
          }
        }
      }
      return Number(Big(count).toString());
    },
    selectOne (selection, row) {
      if (row.isSelect) {
        row.isSelect = false;
        row.transferAmount = this.judgeMaxMoney(row);
      } else {
        row.isSelect = true;
        row.transferAmount = 0;
      }
      this.multipleSelection = selection;
    },
    selectAll (selection) {
      this.multipleSelection = [];
      if (selection.length) {
        selection.forEach((row) => {
          row.isSelect = false;
          row.transferAmount = this.judgeMaxMoney(row);
          this.multipleSelection.push(row);
        });
      } else {
        this.tableData.forEach((row) => {
          row.isSelect = true;
          row.transferAmount = 0;
        });
      }
    },
    confirmTransfer () {
      // 判断 订单金额 * 30% > 返利可用余额
      if (this.allow > this.availableRebateAmount) {
        // 已选返利金额 > 返利可用余额
        if (this.totalChoose > this.availableRebateAmount && this.yanzheng) {
          return (this.$notify.warning('使用返利总金额不可超过最大可用返利金额'));
        }
      } else {
        // 已选返利金额 > 订单金额 * 30%
        if (this.totalChoose > this.allow && this.yanzheng) {
          return (this.$notify.warning('使用返利总金额不可超过最大可用返利金额'));
        }
      }

      let list = [];
      this.multipleSelection.forEach((item) => {
        if (Number(item.transferAmount)) {
          list.push({
            rebateNumber: item.rebateNumber,
            useAmount: item.transferAmount,
            availableAmount: item.availableAmount,
            strRebateType: item.strRebateType
          });
        }
      });
      this.$emit('chooesSuccess', { list, total: this.totalChoose });
      this.dialogVisible = false;
    },
    transferAmountBlur (row) {
      // 比较 是否大于可使用余额
      if (row.availableAmount < row.transferAmount) {
        row.transferAmount = row.availableAmount;
        this.$notify.warning('不可超过最大可用可用余额');
      }
    },
    setDeductionDevice () {
      console.log(this.multipleForm, this.tableData);
      // 将multipleFrom.transferAmountTotal存为临时变量，如果行内isSelect为false，则进行以下逻辑
      // 如果这个变量大于row.availableAmount，则row.transferAmount = row.availableAmount，变量 = 变量 - row.availableAmount
      // 如果这个变量小于row.availableAmount，则row.transferAmount = 变量，变量 = 0
      // 如果这个变量等于0，则后里面都是row.transferAmount = 0
      this.$refs.multipleForm.validate((valid) => {
        if (valid) {
          let totalDeduction = this.multipleForm.transferAmountTotal;
          this.tableLoading = true;
          this.$refs.multipleTable.clearSelection();
          this.$nextTick(() => {
            this.tableData.forEach((row) => {
              if (totalDeduction > 0) {
                this.$refs.multipleTable.toggleRowSelection(row, true);
                if (totalDeduction >= row.availableAmount) {
                  this.$set(row, 'transferAmount', row.availableAmount);
                  totalDeduction = Number(Big(totalDeduction).minus(row.availableAmount).toString());
                } else {
                  this.$set(row, 'transferAmount', totalDeduction);
                  totalDeduction = 0;
                }
                this.$set(row, 'isSelect', false);
              } else {
                this.$set(row, 'transferAmount', 0);
                this.$set(row, 'isSelect', true);
              }
            });
            this.tableLoading = false;
            if (totalDeduction > 0) {
              this.$message({
                type: 'error',
                message: '扣减总金额大于返利可用余额，请修改扣减总金额后再进行扣减。'
              });
            }
            this.multipleSelection = this.tableData.filter((item) => {
              if (!item.isSelect) {
                return true;
              }
            });
          });
        } else {
          return false;
        }
      });
    },
    getMaxNumber () {
      // 获取tableData中所有availableAmount的和与availableRebateAmount的三分之一比较，返回较小的数，要考虑精度问题
      let count = 0;
      this.tableData.forEach((item) => {
        count = numAdd(count, item.availableAmount);
      });
      // return Math.min(count, MathMulti(this.availableRebateAmount, 0.3));
      return this.yanzheng && this.allow > this.availableRebateAmount ? this.availableRebateAmount : this.allow;
    }
  },
  mounted () {
    this.getUser();
  }
};
</script>
